import React from 'react'
import { ProductsListItem } from './ProductsListItem'
import type { Props } from './types'

export const ProductsList = ({ children }: Props) => {
  return <ul>{children}</ul>
}

ProductsList.Item = ProductsListItem
